import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@app/classes';
import { ConfirmationDialogComponent } from '@app/components';
import { FeatureFlag } from '@app/enums';
import { Template } from '@app/models/performance/template.model';
import { AuthService } from '@app/services';
import { FeatureService } from '@app/services/feature.service';
import { BaseForm } from '@forms/base.form';
import { Survey } from '@models/performance/survey.model';

@Component({
    selector: 'app-form-survey-details',
    templateUrl: './survey-details.template.html',
    styleUrls: ['./survey-details.form.scss'],
})
export class SurveyDetailsForm extends BaseForm implements OnInit {
    @Input() survey: Survey;
    @Input() selectedTemplate: Template;

    @Output() templatesLoaded: EventEmitter<Template[]> = new EventEmitter<Template[]>();

    @ViewChild('confirmNavigation') confirmNavigation: ConfirmationDialogComponent;

    canViewHelperText = false;
    hasPerformanceModuleSplit = false;

    constructor(
        private readonly router: Router,
        private readonly auth: AuthService,
        private featureService: FeatureService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.hasPerformanceModuleSplit = await this.featureService.has(FeatureFlag.performanceModuleSplit);

        this.canViewHelperText = this.auth.can([
            ...Platform.permission.administrate,
            ...(this.hasPerformanceModuleSplit ? Template.surveyPermission.all : Template.performancePermission.all),
            ...Survey.permission.all,
        ]);
    }

    templateChanged(event): any {
        this.survey.templateId = event?.id;
    }

    async goToTemplatesClicked(): Promise<void> {
        const confirmed = await this.confirmNavigation.open();

        if (confirmed) {
            this.router.navigate(['/surveys/center/templates']);
        }
    }
}
